import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { ViolinPlot } from "../components/ViolinPlot";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.violin_tool_name()}
        toolPath="/violin-plot"
      />
      <SciHeader title={m.violin_h1()} intro={m.violin_intro()} />

      <ViolinPlot />

      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.violin_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.violin_ex1(), m.violin_ex2(), m.violin_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.violin_faq_q1(), a: m.violin_faq_a1() },
          { q: m.violin_faq_q2(), a: m.violin_faq_a2() },
          { q: m.violin_faq_q3(), a: m.violin_faq_a3() },
          { q: m.violin_faq_q4(), a: m.violin_faq_a4() },
        ]}
      />

      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
